/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TruckInfoVo
 */
export interface TruckInfoVo {
    /**
     * 货车入库号
     * @type {string}
     * @memberof TruckInfoVo
     */
    truckInboundNumber?: string;
    /**
     * 车辆信息车牌号
     * @type {string}
     * @memberof TruckInfoVo
     */
    vehicleInformation?: string;
    /**
     * 司机手机号
     * @type {string}
     * @memberof TruckInfoVo
     */
    driverTelephone?: string;
    /**
     * 货盘数量
     * @type {number}
     * @memberof TruckInfoVo
     */
    palletNumber?: number;
    /**
     * 箱数
     * @type {number}
     * @memberof TruckInfoVo
     */
    boxNumber?: number;
    /**
     * 到达时间
     * @type {string}
     * @memberof TruckInfoVo
     */
    arrivedTime?: string;
    /**
     * 运单ID
     * @type {number}
     * @memberof TruckInfoVo
     */
    waybillId?: number;
}

/**
 * Check if a given object implements the TruckInfoVo interface.
 */
export function instanceOfTruckInfoVo(value: object): value is TruckInfoVo {
    return true;
}

export function TruckInfoVoFromJSON(json: any): TruckInfoVo {
    return TruckInfoVoFromJSONTyped(json, false);
}

export function TruckInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TruckInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'truckInboundNumber': json['truckInboundNumber'] == null ? undefined : json['truckInboundNumber'],
        'vehicleInformation': json['vehicleInformation'] == null ? undefined : json['vehicleInformation'],
        'driverTelephone': json['driverTelephone'] == null ? undefined : json['driverTelephone'],
        'palletNumber': json['palletNumber'] == null ? undefined : json['palletNumber'],
        'boxNumber': json['boxNumber'] == null ? undefined : json['boxNumber'],
        'arrivedTime': json['arrivedTime'] == null ? undefined : json['arrivedTime'],
        'waybillId': json['waybillId'] == null ? undefined : json['waybillId'],
    };
}

export function TruckInfoVoToJSON(json: any): TruckInfoVo {
    return TruckInfoVoToJSONTyped(json, false);
}

export function TruckInfoVoToJSONTyped(value?: TruckInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'truckInboundNumber': value['truckInboundNumber'],
        'vehicleInformation': value['vehicleInformation'],
        'driverTelephone': value['driverTelephone'],
        'palletNumber': value['palletNumber'],
        'boxNumber': value['boxNumber'],
        'arrivedTime': value['arrivedTime'],
        'waybillId': value['waybillId'],
    };
}

